import { SortOrderType } from '@repo/common';

import { UrlSearchFilterProperty } from '@/constants';
import { useGetPurchaseSummaryQuery } from '@/features/slice/report';
import { useUrlFilter } from '@/hooks';
import {
    CUSTOMER_ID_FILTER_KEY,
    CUSTOMER_TYPE_FILTER_KEY,
    PAYMENT_STATUS_FILTER_KEY,
} from '@/modules/sales/order-list/constant';

import { mapDateObjectToString } from '../../../utils/mappers/map-date-object-to-string.mapper';

export const usePurchaseSummary = () => {
    const { debouncedSearchText, getSearchFilter } = useUrlFilter({
        defaultSortBy: 'created_at',
        defaultSortOrder: SortOrderType.DESC,
    });

    const customerType = getSearchFilter(CUSTOMER_TYPE_FILTER_KEY) || undefined;
    const paymentStatus =
        getSearchFilter(PAYMENT_STATUS_FILTER_KEY) || undefined;
    const customerId = getSearchFilter(CUSTOMER_ID_FILTER_KEY) || undefined;

    const fromDate =
        getSearchFilter(UrlSearchFilterProperty.DATE_FROM) || undefined;
    const toDate =
        getSearchFilter(UrlSearchFilterProperty.DATE_TO) || undefined;

    const queryParams: Record<string, string> = {};

    if (debouncedSearchText) {
        queryParams['search'] = debouncedSearchText;
    }
    if (customerType) {
        queryParams['customer_type'] = customerType;
    }
    if (paymentStatus) {
        queryParams['payment_status'] = paymentStatus;
    }
    if (customerId) {
        queryParams['customer_id'] = customerId;
    }

    if (fromDate) {
        const dateObj = new Date(fromDate);
        // const isoString = dateObj.toISOString();
        queryParams['start_date'] = mapDateObjectToString(dateObj);
    }
    if (toDate) {
        const dateObj = new Date(toDate);
        // const isoString = dateObj.toISOString();
        queryParams['end_date'] = mapDateObjectToString(dateObj);
    }

    const { data, isError, isFetching, isLoading, error } =
        useGetPurchaseSummaryQuery(queryParams);
    return {
        data,
        isError,
        isFetching,
        isLoading,
        error,
    };
};
